export class RateCodeMapItem {
  constructor(public utilityAccountNumber: string, public rateCode: string) {}
}
